"use strict";

Shopify.theme.jsRelatedPostsSlider = {
  init: function init($section) {

    var slider = $('.related-blogs--content');

    if ($(window).width() < 800) {
    this.createSlider(slider);
    }

  },
  createSlider: function createSlider(slider) {
    var $relatedArticle = slider.flickity({
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      contain: true,
    }); // Reset layout to avoid collapsing issues

    setTimeout(function () {
      $relatedArticle.flickity('resize');
    }, 500);
  }
};